import classNames from "classnames";

function Skeleton({ times, className }) {
  const outerClassNames = classNames(
    "relative",
    "overflow-hidden",
    "bg-gray-200",
    "rounded",
    "mb-2.5",
    className
  );
  const innerClassNames = classNames(
    "animate-shimmer",
    "absolute",
    "inset-0",
    "-translate-x-full",
    "bg-gradient-to-r",
    "from-gray-200",
    "via-white",
    "to-gray-200"
  );
  const boxes = Array(times)
    .fill(0)
    .map((_, i) => {
      return (
        <tbody key={i}>
          <tr>
            <td>
              <div className="animate-pulse flex-row items-center justify-center space-x-1 rounded-xl p-6 ">
                <div className="h-6 w-11/12 rounded-md bg-gray-300 "></div>
              </div>
            </td>
            <td>
              <div className="animate-pulse flex-row items-center justify-center space-x-1 rounded-xl p-6 ">
                <div className="h-6 w-11/12 rounded-md bg-gray-300 "></div>
              </div>
            </td>
            <td>
              <div className="animate-pulse flex-row items-center justify-center space-x-1 rounded-xl p-6 ">
                <div className="h-6 w-11/12 rounded-md bg-gray-300 "></div>
              </div>
            </td>
            <td>
              <div className="animate-pulse flex-row items-center justify-center space-x-1 rounded-xl p-6 ">
                <div className="h-6 w-11/12 rounded-md bg-gray-300 "></div>
              </div>
            </td>
            <td>
              <div className="animate-pulse flex-row items-center justify-center space-x-1 rounded-xl p-6 ">
                <div className="h-6 w-11/12 rounded-md bg-gray-300 "></div>
              </div>
            </td>
            <td>
              <div className="animate-pulse flex-row items-center justify-center space-x-1 rounded-xl p-6 ">
                <div className="h-6 w-11/12 rounded-md bg-gray-300 "></div>
              </div>
            </td>
            <td>
              <div className="animate-pulse flex-row items-center justify-center space-x-1 rounded-xl p-6 ">
                <div className="h-6 w-11/12 rounded-md bg-gray-300 "></div>
              </div>
            </td>
          </tr>
        </tbody>
      );
    });
  return boxes;
}
export default Skeleton;
